import Vue from 'vue'
import VueRouter from 'vue-router'
import XmlMaker from '../views/xml-maker.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'xml-maker',
    component: XmlMaker
  }
]

const router = new VueRouter({
  routes
})

export default router
